// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat-exclamation-mark';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313 14.063H8.438l-4.5 3.374v-3.375h-2.25a1.125 1.125 0 0 1-1.125-1.124V1.688A1.125 1.125 0 0 1 1.688.563h14.624a1.125 1.125 0 0 1 1.125 1.125v11.25a1.125 1.125 0 0 1-1.125 1.124z' />
    <path d='M9.563 11.25a.281.281 0 1 1 0-.563m0 .563a.281.281 0 1 0 0-.563m0-2.249v-4.5' />
  </g>
);

export const viewBox = '0 0 18 18';
